import { render, staticRenderFns } from "./SubjectTable.vue?vue&type=template&id=f20c705c&scoped=true"
import script from "./SubjectTable.vue?vue&type=script&lang=js"
export * from "./SubjectTable.vue?vue&type=script&lang=js"
import style0 from "./SubjectTable.vue?vue&type=style&index=0&id=f20c705c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20c705c",
  null
  
)

export default component.exports